__turbopack_context__.v({
  "field": "field-controller-module-scss-module__kJVHBG__field",
  "field__error-icon": "field-controller-module-scss-module__kJVHBG__field__error-icon",
  "field__hint": "field-controller-module-scss-module__kJVHBG__field__hint",
  "field__label": "field-controller-module-scss-module__kJVHBG__field__label",
  "field__label--select": "field-controller-module-scss-module__kJVHBG__field__label--select",
});
